import { FC, useEffect, useRef, useState } from 'react';

import { Mobile, Web } from '~src/styles/containers.sc';

import { ArrowContainer, ButtonContainer, CircleContainer, InnerCircle } from './timeOutButton.sc';

interface Props {
  time: number;
  finishedCall: () => void;
  progress: number;
  onClick: () => void;
  start: boolean;
}

export const circleParts = 200;

const calcProgress = (value: number, total: number, r: number) => {
  let center;
  const position = r + 10;
  const alpha = (360 / total) * value;
  const a = ((90 - alpha) * Math.PI) / 180;
  const x = position + r * Math.cos(a);
  const y = position - r * Math.sin(a);
  let path;
  if (total === value) {
    path = `M${position},${position - r} A${r},${r},${0},${1},${1},${position - 0.001},${position - r}`;
  } else {
    if (alpha > 180) {
      center = 1;
    } else {
      center = 0;
    }
    path = `M${position},${position - r} A${r},${r},${0},${center},${1},${x},${y}`;
  }
  return path;
};

function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      callback = savedCallback.current;
      if (callback) {
        callback();
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const TimeOutButton: FC<Props> = (props) => {
  const [progress, setProgress] = useState(props.progress);
  const [isRunning, setIsRunning] = useState(props.start);

  useInterval(
    () => {
      if (progress >= circleParts) {
        setIsRunning(false);
        props.finishedCall();
      } else {
        setProgress(progress + 1);
      }
    },
    isRunning ? props.time / circleParts : null,
  );

  // start or stop the timeoutbutton
  useEffect(() => {
    setIsRunning(props.start);
  }, [props.start]);
  return (
    <ButtonContainer onClick={props.onClick}>
      <CircleContainer>
        <Web>
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
            <g fill="none" stroke="white" strokeWidth={2} fillRule="nonzero">
              <path d={calcProgress(progress, circleParts, 30)} />
            </g>
          </svg>
        </Web>
        <Mobile>
          <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65">
            <g fill="none" stroke="white" strokeWidth={2} fillRule="nonzero">
              <path d={calcProgress(progress, circleParts, 22.5)} />
            </g>
          </svg>
        </Mobile>
      </CircleContainer>
      <InnerCircle>
        <ArrowContainer name="iconArrow" />
      </InnerCircle>
    </ButtonContainer>
  );
};

export default TimeOutButton;
